import Icons from 'components/icons';
import { HtmlHTMLAttributes } from 'react';
import styled, { css, SizeItems } from 'styled-components';

const Icon = styled(Icons)<{ size?: SizeItems } & HtmlHTMLAttributes<SVGAElement>>`
  color: ${(props: any) => props.theme.colors[props['data-color'] || 'primary_400']};

  ${({ theme: { mediaQueries }, size = 'small' }) =>
    size === 'small' &&
    css`
      width: 16px;

      ${mediaQueries.desktop} {
        width: 20px;
      }
    `}

  ${({ theme: { mediaQueries }, size = 'medium' }) =>
    size === 'medium' &&
    css`
      width: 25px;

      ${mediaQueries.desktop} {
        width: 30px;
      }
    `};

  ${({ theme: { mediaQueries }, size = 'large' }) =>
    size === 'large' &&
    css`
      width: 40px;

      ${mediaQueries.desktop} {
        width: 44px;
      }
    `};
`;

export default Icon;
